import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Card, Grid, makeStyles, Typography } from '@material-ui/core';
import SVG from 'react-inlinesvg';

import { toAbsoluteUrl } from '../../../../_metronic/_helpers';

const postTypes = [
	{
		name: 'Photos',
		key: 'galleryPost',
		icon: '/assets/photo.svg',
		score: 25,
	},
	{
		name: 'Videos',
		key: 'videoPost',
		icon: '/assets/video.svg',
		score: 56,
	},
	{
		name: 'Outfits',
		key: 'outfitPost',
		icon: '/assets/outfit.svg',
		score: 2,
	},
	{
		name: 'Polls',
		key: 'pollPost',
		icon: '/assets/poll.svg',
		score: -8,
	},
	{
		name: 'Questions',
		key: 'questionPost',
		icon: '/assets/question.svg',
		score: -18,
	},
];

export function Posts() {
	const { statistics } = useSelector((state) => state.dashboard, shallowEqual);
	const [postCount, setPostCount] = useState({
		photos: 0,
		videos: 0,
		outfits: 0,
		polls: 0,
		questions: 0,
	});

	useEffect(() => {
		if (!statistics || !statistics.length) {
			setPostCount({
				photos: 0,
				videos: 0,
				outfits: 0,
				polls: 0,
				questions: 0,
			});
			return;
		}
		const count = {};
		const dailyNewPosts = statistics.map((val) => {
			return {
				...val.metrics.Posts,
			}
		})
		postTypes.forEach((type) => {
			count[type.name.toLowerCase()] = dailyNewPosts.reduce((a, b) => a + (b[type.key] || 0), 0);
		});
		setPostCount(count);
	}, [statistics]);

	const classes = useStyles();

	return (
		<Card className={classes.container}>
			<Grid container justify='space-between' alignItems='center'>
				<div className='d-flex align-items-center'>
					<span className='symbol symbol-circle symbol-50 symbol-light mr-2'>
						<span className='symbol-label'>
							<span className='svg-icon svg-icon-lg svg-icon-dark'>
								<SVG src={toAbsoluteUrl('/assets/posts.svg')}></SVG>
							</span>
						</span>
					</span>
					<div className='d-flex flex-column' style={{ marginLeft: 4 }}>
						<span className={classes.title}>Posts</span>
					</div>
				</div>
			</Grid>
			{postTypes.map((p, index) => (
				<Grid key={index} container justify='space-between' alignItems='center'>
					<div className='d-flex align-items-center'>
						<span>
							<SVG width={'24px'} height={'24px'} src={toAbsoluteUrl(p.icon)}></SVG>
						</span>
						<Typography className={classes.subTitle}>{p.name}</Typography>
					</div>
					<div className='d-flex align-items-center'>
						<Typography className={classes.subContent}>{postCount[p.name.toLowerCase()]}</Typography>
					</div>
				</Grid>
			))}
		</Card>
	);
}

const useStyles = makeStyles(() => ({
	container: {
		padding: 20,
		boxShadow: 'none !important',
		borderRadius: 10,
		height: '100%',
	},
	title: {
		fontSize: 16,
		color: '#353146',
		lineHeight: '16px',
	},
	score: {
		fontSize: 14,
		color: '#908BA4',
	},
	subTitle: {
		fontSize: 16,
		color: '#353146',
		lineHeight: '54px',
		marginLeft: 12,
	},
	subContent: {
		color: '#0D0C12',
		fontSize: 20,
	},
	improve: {
		marginLeft: 12,
		width: 40,
		textAlign: 'right',
	},
}));
